module.exports = __webpack_public_path__ + "static/media/BreastCancer_FFE2877.3c203cdf.jpg";